module.exports = __webpack_public_path__ + "img/360.9cac6b7d.svg";